import React from 'react';
import { Online } from './common/OnlineOffline';

const NetworkStatusObserver = props => {
  return (
    <Online
      onChange={props.onGoOnline}
      onMessageReceived={props.onMessageReceived}
    >
      {/* Must transclude something, otherwise React generates an error */}
      <></>
    </Online>
  );
}

export default NetworkStatusObserver;
